import React from 'react';
import PropTypes from 'prop-types';

export function RemoveConfrimationModal({ show, onClose, handleRemoveEvent, model }) {
    const handleConfirmRemove = () => {
        if (model.title) {
            handleRemoveEvent(model);
            onClose();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                <h2 className="admin-modal-heading">
                    Are you sure you want to remove this patient?
                </h2>
                <div className="admin-modal-row full">
                    <div className="admin-modal-cell">{model.title}</div>
                </div>
                <div className="admin-modal-button-wrap">
                    <button className="admin-modal-button" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="admin-form-button power red"
                        onClick={handleConfirmRemove}

                    >
                        Remove
                    </button>
                </div>
            </div>
        </div>
    );
}

RemoveConfrimationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleRemoveEvent: PropTypes.func.isRequired,
    model: PropTypes.object
};